import { useContext } from 'react';
import { ErrorsContext, GenericsContext, InputsContext, LiferayContext, SearchContext } from '../../contexts';

import type {
  ErrorsContextProps,
  GenericsContextProps,
  IErrorsState,
  IGenericsState,
  IInputsState,
  ILiferayState,
  ISearchState,
  InputsContextProps,
  LiferayContextProps,
  SearchContextProps,
} from '../../types';

type ContextSelector = {
  errors: IErrorsState;
  generics: IGenericsState;
  inputs: IInputsState;
  liferay: ILiferayState;
  search: ISearchState;
  update: {
    errors: ErrorsContextProps['updateErrorsState'];
    generics: GenericsContextProps['updateGenericsState'];
    inputs: InputsContextProps['updateInputsState'];
    liferay: LiferayContextProps['updateLiferayState'];
    search: SearchContextProps['updateSearchState'];
  };
};

export const useContextSelector = () => {
  const { errorsState, updateErrorsState } = useContext(ErrorsContext);
  const { genericsState, updateGenericsState } = useContext(GenericsContext);
  const { inputsState, updateInputsState } = useContext(InputsContext);
  const { liferayState, updateLiferayState } = useContext(LiferayContext);
  const { searchState, updateSearchState } = useContext(SearchContext);

  return {
    errors: errorsState,
    generics: genericsState,
    inputs: inputsState,
    liferay: liferayState,
    search: searchState,
    update: {
      errors: updateErrorsState,
      generics: updateGenericsState,
      inputs: updateInputsState,
      liferay: updateLiferayState,
      search: updateSearchState,
    },
  } as ContextSelector;
};
